import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { IconLoadingDots } from "../../../src/Icons";
import Alert from "../../../src/UI/Alerts/Alert";

export default function Form(props) {
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const elements = useElements();
  const stripe = useStripe();

  const returnUrl = `${window.location.origin}/booking/payment/${props.draftOrderId}/stripe`;

  const handleChange = (event) => {
    setError(event.error ? event.error.message : "");
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const termsAccepted = document.querySelector('input[name="terms_accepted"]')?.checked;
    if (!termsAccepted) { setError("You must accept the Terms and Conditions to proceed."); return; }
    if (!stripe || !elements) { setError("Stripe is not loaded. Please try again."); return; }
    if (!props.clientSecret) { setError("Payment setup is incomplete. Missing client secret."); return; }

    setProcessing(true);

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      const preRes = await fetch(`/booking/payment/${props.draftOrderId}/preconfirm`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ bundle_slug: props.bundleSlug }),
        credentials: "same-origin",
      });

      const pre = await preRes.json().catch(() => ({}));

      if (!preRes.ok || pre.allow === false) {
        setError(pre?.message || "This location is not currently accepting bookings for this scan.");
        return;
      }

      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: returnUrl }
      });

      if (error) {
        setError(`Payment failed. ${error.message}`);
        return;
      }

      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Something went wrong. Please try again.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit} className="space-y-4">
      <PaymentElement id="payment-element" onChange={handleChange} />
      <div className="flex gap-3 mb-6 sm:mb-8">
        <input
          type="checkbox"
          id="terms_accepted_input"
          name="terms_accepted"
          className="form-checkbox shrink-0"
        />
        <label htmlFor="terms_accepted_input">
          I agree to Full Body Scan's{" "}
          <a href={props.termsHref} target="_blank">
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a href="/privacy-policy" target="_blank">
            Privacy Policy
          </a>
          .
        </label>
      </div>
      <button
        id="submit"
        disabled={processing}
        className="button button-primary max-lg:w-full"
      >
        {processing ? (
          <>
            &nbsp;
            <IconLoadingDots />
          </>
        ) : (
          <span> Pay {props.cost}</span>
        )}
      </button>

      {error && <Alert type="error">{error}</Alert>}
    </form>
  );
}
